import React, { useRef } from "react";
import { Button, Form } from "react-bootstrap";
import { useGetDocumentsQuery } from "../../../../../services/api/repositories/DocumentsRepository";
import TableDocument from "../TableDocument";
import { IDocument } from "../../../../../interfaces/api/IDocuments";

export default function DocumentInput(
    { documentUuidList, handleDocumentUuidAdd, handleDocumentUuidRemove }: { documentUuidList: string[], handleDocumentUuidAdd: (arg0: string) => void, handleDocumentUuidRemove: (arg0: string) => void }) {
    const documentsQuery = useGetDocumentsQuery({ disabled_pagination: true });
    const documentRef = useRef<HTMLSelectElement>(null);

    let documentList: IDocument[] | undefined = [];
    if (!documentsQuery.isLoading && documentsQuery.data && "documents" in documentsQuery.data && documentsQuery.data.documents) {
        documentList = documentsQuery.data.documents.filter((document) =>
            documentUuidList.includes(document.uuid)
        );
    }

    const handleDocumentAdd = () => {
        if (documentRef.current?.value) {
            handleDocumentUuidAdd(documentRef.current?.value);
        }
    }
    return (
        <Form.Group className="form-group attachs">
            <Form.Label className="form-label" htmlFor="mailing-email-attach-select">Pièces jointes</Form.Label>
            <p className="form-help">Les Pièces jointes sélectionnées seront jointes à l'email lors de chaque envoi à chaque destinataire.</p>
            {(documentList !== undefined) &&
                (
                    <TableDocument
                        documentList={documentList}
                        handleDocumentUuidRemove={handleDocumentUuidRemove} />
                )
            }
            <div className="form-addItem">
                <Form.Label className="form-label" htmlFor="mailing-email-attachments-addAttachment">Ajouter une Pièce jointe</Form.Label>
                <Form.Select className="form-select" id="mailing-email-attachments-addAttachment" tabIndex={9} ref={documentRef} defaultValue={"none"}>
                    <option value="none" disabled>Sélectionner une Pièce jointe</option>
                    {documentsQuery.isLoading && <option>Chargement...</option>}
                    {!documentsQuery.isLoading && (
                        <>
                            {documentsQuery.data && "documents" in documentsQuery.data && documentsQuery.data.documents &&
                                documentsQuery.data.documents.map(document => <option key={document.uuid} value={document.uuid}>{document.name}</option>)
                            }
                        </>
                    )
                    }
                </Form.Select>
                <Button type="button" className="btn btn-primary btn-sm btn-add" title="Ajouter la Pièce jointe" onClick={handleDocumentAdd}>
                    <span className="icon"></span>
                    <span className="text">Ajouter</span>
                </Button>
            </div>
        </Form.Group >
    );
}